"use client";

import React, { ReactNode, Suspense, useEffect, useState } from "react";

import { FilterProduct, ProductCollectionJson } from "@/types/Product.type";

import Skeleton from "@/components/Skeleton";
import ShareSocial from "@/components/ShareSocial";
import ProductList from "~components/product/children/ProductList";
import ProductFilter from "~components/productFilter/ProductFilter";
import ProductFilterSelect from "~components/productFilter/ProductFilterSelect";
import ProductFilterMobile from "~components/productFilter/productFilterMobile/ProductFilterMobile";
import { AdsItem } from "@/types/Collection.type";
import { selectDevice } from "@/redux/features/ShopSlice";
import { useAppSelector } from "@/redux/hook";
import ProductListLoading from "./children/ProductListLoading";
import { cn } from "@/utils/utils";

type Props = {
	products: ProductCollectionJson;
	title: ReactNode;
	linkShare?: string;
	defaultFilter: FilterProduct;
	isBrand?: boolean;
	collectionHandle?: string;
	settingAds?: AdsItem[];
	isApplyAds?: boolean;
	isLoading?: boolean;
	titleProps?: {
		className?: string;
	};
};
export default function ProductListHasFilter({
	products,
	title,
	linkShare,
	defaultFilter,
	isBrand,
	collectionHandle,
	settingAds,
	isApplyAds,
	isLoading,
	titleProps,
}: Props) {
	const device = useAppSelector(selectDevice);
	const [loading, setLoading] = useState(isLoading);

	useEffect(() => {
		setLoading(false);
	}, [products]);
	return (
		<div className="grid md:gap-6 grid-cols-12 md:mt-4">
			<div
				className={cn(
					"col-span-6 md:flex hidden gap-[30px] items-center",
					titleProps?.className
				)}>
				{title}
				{loading ? (
					<Skeleton className="h-4 w-20 rounded-sm" />
				) : (
					<span className="text-base leading-[22px] text-gray-500 hidden md:block">
						{products.total} kết quả
					</span>
				)}
			</div>
			<div className="col-span-6 md:block hidden">
				<div className="flex gap-2 h-full items-center justify-end">
					{linkShare && (
						<ShareSocial
							className="px-[0px]"
							shareButtonProps={{
								url: linkShare,
							}}
						/>
					)}
					<ProductFilterSelect />
				</div>
			</div>

			{device === "mobile" ? (
				<div className="md:hidden col-span-12">
					<ProductFilterMobile
						onLoad={(l) => {
							setLoading(l);
						}}
						collectionHandle={collectionHandle}
					/>
				</div>
			) : (
				<div className="col-span-2 flex-shrink-0 md:block hidden">
					<ProductFilter
						defaultFilter={defaultFilter}
						collectionHandle={collectionHandle}
						onLoad={(l) => {
							setLoading(l);
						}}
						is_brand={isBrand}
					/>
				</div>
			)}
			<div className="md:col-span-10 col-span-12 pb-5">
				<ProductList
					isApplyAds={isApplyAds}
					settingAds={settingAds}
					data={products}
					collectionHandle={collectionHandle}
					isLoading={loading}
				/>
			</div>
		</div>
	);
}
